<template>
    <div>
        <div class="top">
            <van-nav-bar title="招生信息" left-text="返回" left-arrow @click-left="onClickLeft" />
        </div>
        <div class="menu">
            <div
                :class="currentId === item.id?'menu-item-on':'menu-item-off'"
                v-for="item in tabs"
                :key="item.id"
                @click="selectMenu(item)"
            >{{item.name}}</div>
        </div>
        <div class="content" v-if="currentId === 20">
            <div class="news-item" v-for="item in mark20" :key="item.id" @click="goZSDetail(item)">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
        <div class="content" v-if="currentId === 21">
            <div class="news-item" v-for="item in mark21" :key="item.id" @click="goZSDetail(item)">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
        <div class="content" v-if="currentId === 22">
            <div class="news-item" v-for="item in mark22" :key="item.id" @click="goZSDetail(item)">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
        <div class="content" v-if="currentId === 23">
            <div class="news-item" v-for="item in mark23" :key="item.id" @click="goZSDetail(item)">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
        <div class="content" v-if="currentId === 27">
            <div class="news-item" v-for="item in mark27" :key="item.id" @click="goZSDetail(item)">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";

export default {
    name: "zhaosheng",
    data() {
        return {
            currentId: 27,
            mark20: [],
            mark21: [],
            mark22: [],
            mark23: [],
            mark27: [],
            tabs: []
        };
    },
    methods: {
        // 点击进入详情
        goZSDetail(e){
           
            this.$router.push({
                path:'/zhaoxin/zhaoxinDetail',
                query:{
                    id:e.id,
                    schoolId:this.$route.query.id
                }
            })
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        selectMenu(item) {
            this.currentId = item.id;
        },
        loadInfo() {
            httpPost("/saas/lists", {
                schoolid: this.$route.query.id,
                mark: 3
            }).then(response => {
              
                if (response.code === 1) {
                    this.tabs = response.tabs;
                    this.mark20 = response.mark20;
                    this.mark21 = response.mark21;
                    this.mark22 = response.mark22;
                    this.mark23 = response.mark23;
                    this.mark27 = response.mark27;
                 
                }
            });
        }
    },
    mounted() {
        this.loadInfo();
    }
};
</script>

<style scoped>
.menu {
    display: flex;
    font-size: 1rem;
    border-bottom: 0.05rem solid #ccc;
}
.menu-item-on,
.menu-item-off {
    width: 20vw;
    text-align: center;
    padding: 0.5rem 0;
}
.menu-item-on {
    color: #25bafd;
}
.news-item {
    padding: 0.8rem 0;
    border-bottom: 0.05rem solid #ccc;
}
.news-title {
    font-size: 1rem;
    padding-left: 0.3rem;
    padding-bottom: 0.5rem;
}
.create-time {
    padding-left: 0.3rem;
    padding-top: 0.6rem;
    color: #999;
}
</style>